import SharingArrangementDefeasedLoansPopup from './SharingArrangementDefeasedLoansPopup';

export default SharingArrangementDefeasedLoansPopup;
